<template>
    <div class="container-layout" :class="{ 'container-selecionado': isSelected }">
        <div class="overlay-container-pai">
            <slot name="overlaySelecao" />
        </div>

        <Dropzone :componenteId="componenteId" :dropzone-class="dropzoneClasses" :placeholder-class="placeholderClasses" :dropzoneStyle="style">
            <template #placeholder>
                <span class="material-symbols-outlined" style="font-size: 36px">swipe_right</span>
            </template>
        </Dropzone>
    </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { useEditorLandingPage } from '@/composables/useEditorLandingPage';
import Dropzone from '@/components/editorLandingPage/core/Dropzone.vue';

const props = defineProps({
    componenteId: {
        type: String,
        required: true,
    },
    style: {},
});

const { idElementoSelecionado } = useEditorLandingPage();

const isSelected = computed(() => props.componenteId === idElementoSelecionado.value);

const dropzoneClasses = computed(() => ({
    'container-dropzone': true,
    [`direction-${props.direcao}`]: true,
    selected: isSelected.value,
}));

const placeholderClasses = computed(() => ['container-placeholder', isSelected.value ? 'selected' : '']);
</script>

<style scoped lang="scss">
.container-layout {
    position: relative;
    width: 100%;
    border-radius: 8px;
    transition: all 0.2s ease;
    border: 2px solid transparent;
    box-sizing: border-box;
    padding: 22px;

    &.container-selecionado {
        background-color: #eaf6fb !important;
    }
}

:deep(.container-dropzone) {
    display: flex;
    gap: 12px;
    min-height: 150px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 2px dashed #d4d4d4;
    border-radius: 4px;

    &.selected {
        border: 2px dashed var(--primary-color);
        background-color: #cbe7f3;
    }

    &.direction-column {
        flex-direction: column;
        align-items: v-bind('props.alinhamento');
        justify-content: v-bind('props.justificacao');
    }

    &.direction-row {
        flex-direction: row;
        align-items: v-bind('props.alinhamento');
        justify-content: v-bind('props.justificacao');
    }
}

:deep(.container-placeholder) {
    border-radius: 4px;
    height: 100%;
    min-height: 120px;
    width: 100%;

    &.selected {
        color: var(--primary-color);
    }
}

.overlay-container-pai {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
}

.overlay-container-pai :deep(.overlay-header) {
    pointer-events: auto;
}

.opacity-25 {
    opacity: 0.25;
}

.opacity-60 {
    opacity: 0.6;
}
</style>
